import MsTag from './src/Tag.vue'

export default MsTag
